<template>
  <p :class="$style.container">
    <i :class="[iconClass, $style.icon]" />
    <slot />
  </p>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'HintText',
  props: {
    iconClass: {
      type: String,
      default: 'far fa-star',
    },
  },
});
</script>

<style lang="scss" module>
.container {
  @include font(13, regular, description);
  position: relative;
  padding-left: 13px * 1.5;
  color: $COLOR_BASE_DEEP;

  &:not(:first-child) {
    margin-top: 10px;
  }

  & + .container {
    margin-top: 3px;
  }

  strong {
    font-weight: bold;
  }
}

.icon {
  color: $COLOR_PRIMARY;
  position: absolute;
  top: 3px;
  left: 0;
  width: 13px;
  text-align: center;
}
</style>
